/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 4/23/15.
 */

angular.module('prism-ui.components.data').factory('MediaProfileResourceFactory',
    ($resource: JS5Function, EndPointService: JS5Object) => {
		return $resource(
		    EndPointService.mediaProfileEndPoint,
            {},
            {
                validate: {
                    method: 'GET',
                    url: `${EndPointService.mediaProfileEndPoint}/validate`,
                    params: {
                        path: '@path',
                        profileId: '@profileId'
                    }
                },
                validateXML: {
                    method: 'POST',
                    url: `${EndPointService.mediaProfileEndPoint}/validate`,
                    params: {
                        profileId: '@profileId'
                    }
                },
                validateCCSubtitle: {
                    // this is for remote upload timed text
                    // validation
                    method: 'POST',
                    url: `${EndPointService.mediaProfileEndPoint}/validate/closedCaption`
                },
                validateClosedCaption: {
                    // this is for traditional/repository based
                    // text validation
                    method: 'GET',
                    url: `${EndPointService.mediaProfileEndPoint}/validateClosedCaption`,
                    params: {
                        ccPath: '@ccPath',
                        videoMediaId: '@videoMediaId',
                        videoPath: '@videoPath',
                        videoAcceptTemplateMemberId: '@videoAcceptTemplateMemberId',
                        textAcceptTemplateId: '@textAcceptTemplateId'
                    }
                },
                validatePrePostRoll: {
                    method: 'GET',
                    url: `${EndPointService.mediaProfileEndPoint}/validate/prePostRoll`,
                    params: {
                        path: '@path',
                        profileId: '@profileId'
                    }
                },
                validateVideoComponents: {
                    method: 'POST',
                    url: `${EndPointService.mediaProfileEndPoint}/validate/videoComponent`
                },
                validateAdPod: {
                    method: 'POST',
                    url: `${EndPointService.mediaProfileEndPoint}/validate/adPod`
                }
		});
	});
